import { useEffect, useRef, useState } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import calendarDate from "../../assets/images/calendar-date.svg"
import { Form, Image } from 'react-bootstrap';
import "./InputBox.css"
import { formatDate } from '../../helpers/date-formatter';

function DatePicker(props) {
    // let inputRef = useRef();
    const [focus, setFocus] = useState(false);
    const [value, setValue] = useState("")
    const validateInput = () => {
        setFocus(false);
        allValidations();
    }
    const validateMandatory = () => {
        if ((!props.value || props.value === "")) {
            return props.label + " is mandatory";
        } else {
            return "";
        }
    }

    const allValidations = () => {
        let errorMsg = "";
        if (props.required && !props.readOnly) {
            errorMsg = validateMandatory()
        }
        if (props.value && props.value !== "") {
            if (props.customValidation) {
                errorMsg = props.customValidation(props.value, props.name);
            }
        }
        if (props.setError) { props.setError((prev) => ({ ...prev, [props.name]: errorMsg })); }
    }

    useEffect(() => {
        if (props.submit) {
            props.setFieldCount((prev) => ([...prev, props.name]));
            allValidations();
        }
    }, [props.submit]);

    // useEffect(() => {
    //     if (props.focusInd) {
    //         inputRef.current.focus();
    //     }
    // }, [props.focusInd]);

    useEffect(() => {
        let tempValue = "";
        if (props.value.fromDate && props.value.fromDate != "" && props.value.toDate && props.value.toDate != "") {
            const fromParts = props.value.fromDate.split('-');
            const toParts = props.value.toDate.split('-');
            const fromDate = parseInt(fromParts[1]) + '/' + parseInt(fromParts[2]) + '/' + fromParts[0];
            const toDate = parseInt(toParts[1]) + '/' + parseInt(toParts[2]) + '/' + toParts[0];
            tempValue = fromDate + " - " + toDate;
        }
        setValue(tempValue);
        allValidations();
    }, [props.value]);

    return (
        <DateRangePicker
            initialSettings={{ ...{ showDropdowns: true }, ...props.initialSettingsProps }}
            onApply={(event, picker) => {
                console.log('DateRangePicker onApply - start:', picker.startDate.format('YYYY-MM-DD'));
                console.log('DateRangePicker onApply - end:', picker.endDate.format('YYYY-MM-DD'));
                const formattedDates = {
                    fromDate: picker.startDate.format('YYYY-MM-DD'),
                    toDate: picker.endDate.format('YYYY-MM-DD')
                };
                props.onChange({ target: { name: props.name, value: formattedDates } });
            }}
        >
            <Form.Group className={`g-input`}>
                <Form.Control
                    className={` ${props.className} ${props.error && props.error[props.name] ? "text-field-with-error " : ""}`}
                    {...props}
                    onBlur={(e) => { validateInput(); }}
                    autoComplete="off"
                    id={props.name}
                    value={value}
                    key={value}
                // ref={inputRef}
                />
                <Form.Label className={`${(focus || (value && value != "")) ? "active" : ""} ${props.error && props.error[props.name] ? "text-label-with-error" : ""}`} htmlFor={props.name}>
                    {props.label}
                    {(!props.required || props.readOnly == false) && <span className="optional"> (optional)</span>}
                </Form.Label>
                <Image src={calendarDate} className="calendar-btn" ></Image>
                {props.error && props.error[props.name] && (
                    <Form.Text className="text-danger">
                        {props.error[props.name]}
                    </Form.Text>
                )}
            </Form.Group>
        </DateRangePicker >
    );
}

export default DatePicker